import templateUrl from 'emun.vendor/agency-selector.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import ServiceBus from 'servicestack/service-bus'
import modals from 'webmodals/modals'

class AgencySelectorController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.bus = new ServiceBus();
        $ctrl.bus
        .send("QueryAgencies.json?Active=1&VendorId=" + $ctrl.vendorId)
        .then(function(res) {
            $ctrl.agencies = res.data.results;
        });
    }
    gotoPortal(agency) {
        const $ctrl = this;
        window.location = agency.vendorPortalUrl;
    }
}

export default {
	bindings: {
        vendorId: '@'
	},
    controller: AgencySelectorController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};